import { render, staticRenderFns } from "./ECommerceData.vue?vue&type=template&id=43732452&scoped=true&"
import script from "./ECommerceData.vue?vue&type=script&lang=js&"
export * from "./ECommerceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43732452",
  null
  
)

export default component.exports